import { render } from "./ProductVignette.vue?vue&type=template&id=5a42f62c&scoped=true"
import script from "./ProductVignette.vue?vue&type=script&lang=js"
export * from "./ProductVignette.vue?vue&type=script&lang=js"

import "./ProductVignette.vue?vue&type=style&index=0&id=5a42f62c&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a42f62c"]])

export default __exports__